import React from 'react'

const  TitleView = ({title})=>{
    return(
        <div className='titleSize'>
            <h2 className='SecondTitleText'>{title}</h2>
        </div>
    )
}
export default TitleView